import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response';
import { OrganizationLicence } from '../../models/organization-licence';
import { ExpiringLicence } from '../../models/expiring-licence';

@Injectable({ providedIn: 'root' })
export class LicencesService {
  constructor(private http: HttpClient) { }

  getLicences(
    organizationId: string,
    page: number,
    size: number
  ): Observable<ApiResponse<OrganizationLicence[]>> {
    const params = new HttpParams()
      .set('page', page)
      .set('size', size);

    return this.http.get<ApiResponse<OrganizationLicence[]>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/licences`,
      { params }
    );
  }

  createLicence(
    organizationId: string,
    request: {
      durationDays: number;
      gracePeriodDays: number;
    }
  ) {
    return this.http.post<ApiResponse<OrganizationLicence>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/licences`,
      request
    );
  }

  renewLicence(
    organizationId: string,
    licenceId: string,
    request: { additionalDays: number }
  ) {
    return this.http.post<ApiResponse<OrganizationLicence>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/licences/${licenceId}/renew`,
      request
    );
  }

  suspendLicence(organizationId: string, licenceId: string) {
    return this.http.post<ApiResponse<OrganizationLicence>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/licences/${licenceId}/suspend`,
      {}
    );
  }

  revokeLicence(organizationId: string, licenceId: string) {
    return this.http.post<ApiResponse<OrganizationLicence>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/licences/${licenceId}/revoke`,
      {}
    );
  }
  
  getExpiringSoon(days: number = 30) {
    return this.http.get<ApiResponse<ExpiringLicence[]>>(
      `${environment.apiBaseUrl}/admin/licences/expiring-soon?days=${days}`
    );
  }
}